export default "__VITE_ASSET__MjACF7nk__"